// extracted by mini-css-extract-plugin
module.exports = {"bg":"_1ZNMx","inlineContent":"l4R05","pageWrapper":"Em8dO","root":"_2hsyZ"};